<template>
  <div class="attentionPop" id="attentionPop" v-if="show" >
    <div class="attentionPop_div">
      <img class="attentionPop_div_bg" src="../../assets/img/attention_pop_bg.png" alt="">
      <div class="closeBtn" v-if="!canClose" @click="canCloseFn"><img src="../../assets/img/close_icon.png" alt=""></div>
      <img v-if="erweimaUrl" :src="erweimaUrl" alt="" class="erweima">
      <img v-if="isPlatform == 'zhengshi'" src="../../assets/img/erweima/qrcode_gz.jpg" alt="" class="erweima">
      <img v-if="isPlatform == 'yufa'" src="../../assets/img/erweima/erweima_yufa.png" alt="" class="erweima">
      <img v-if="isPlatform == 'yufa2'" src="../../assets/img/erweima/erweima_pre2.jpg" alt="" class="erweima"></img>
      <img v-if="isPlatform == 'ceshi'" src="../../assets/img/erweima/erweima_ceshi.jpg" alt="" class="erweima">
    </div>
  </div>
</template>
<script>
export default {
  props: ['show', 'canClose','erweimaUrl'],
  data () {
    return {
      isPlatform:'', // 判断时哪个平台
    }
  },
  mounted () {
    var _self = this
    this.$nextTick(function () {
      if(!this.$utils.isEmpty(this.erweimaUrl)){
        return false
      }else{
        this.erweimaUrl = ''
      }
      if(window.location.host == 'test-syrjia.syrjia.cn' || global.href.indexOf('8080')!=-1){
        this.isPlatform = 'ceshi'
      }else if(window.location.host == 'pre-syrjia.syrjia.cn'){
        this.isPlatform = 'yufa'
      }else if(window.location.host == 'pre2-syrjia.syrjia.cn'){
        this.isPlatform = 'yufa2'
      }else if(window.location.host == 'mobile.syrjia.com'){
        this.isPlatform = 'zhengshi'
      }
    })
    //神策埋点数据
    _self.$utils.scPopupShow("请关注'上医明家公众号',以便及时接收医生发给您的信息",_self)
  },
  methods: {
    canCloseFn(){
      // if(this.canClose){
        let myNode = document.getElementById("attentionPop")
        myNode.remove()
      // }
      if(this.$route && this.$route.path === '/inquiriesStart'){ //领取问诊单未关注 跳转医生主页
        this.$router.push({path: '/doctorindex?tab=0', query: {id: this.$route.query.doctorId}})
      }
    }
  }
}
</script>
<style lang="scss">
.attentionPop{
  position: fixed;
  top:0;
  left:0;
  z-index: 99999;
  background-color: rgba($color: #000000, $alpha: 0.4);
  width: 100%;
  height: 100%;
  -webkit-touch-callout:none;
  -webkit-user-select:none;
  -khtml-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
  .attentionPop_div{
    width: 6.1rem;
    height: 5.86rem;
    margin:2.5rem auto;
    position: relative;
    .attentionPop_div_bg{
      width: 100%;
      height: 100%;
    }
    .erweima{
      position: absolute;
      width: 1.84rem;
      height: 1.84rem;
      top:2.78rem;
      left: 2.17rem;
    }
    .closeBtn{
      position: absolute;
      right: .3rem;
      top: .3rem;
      width: 0.36rem;
      height: .36rem;
      opacity: .5;
      img{
        width: 100%;
        // height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/attentionPop/attentionPop.vue